import React from 'react';
import Accordion from 'components/commercetools-ui/atoms/accordion';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import * as screensizes from 'helpers/utils/screensizes';
import { Reference } from 'types/reference';
import Image, { ImageProps } from 'frontastic/lib/image';
import Column, { FooterLink } from './atoms/column';
import FooterBottom from './footer-bottom';
import { useParams } from 'next/navigation';
import { localeMapping } from 'helpers/constants/localeMapping';
import MarketButton from '../market-button/market-button';
import { NationalBook, NationalSemibold } from 'fonts';

export interface FooterColumn {
  header?: string;
  links?: FooterLink[];
}
export interface Props {
  columns: FooterColumn[];
  logo?: string;
  socialMedia?: any;
  copyright?: any;
}

export interface SocialMedia {
  logo: string;
  reference: Reference;
}


const Footer: React.FC<Props> = ({ columns, logo, socialMedia, copyright }) => {
  const { locale } = useParams();
  const localeKey = localeMapping[locale];
  return (
    <footer
      aria-labelledby="footer-heading"
      className="w-full bg-[#090909] py-48 px-0"
    >
      
      {/* Desktop and Tablet View */}
      <div className="hidden lg:flex w-full items-center justify-between px-[20.5px] md:px-24 md:pt-0 lg:px-48 xl:px-60 2xl:px-80 2xl:py-8 text-base lg:text-sm" style={{ fontSize: 'calc(100% - 2px)' }}>
      <div className="">
        <Image src={logo} alt="logo" width={143} height={26} />
      </div>
      <div className={`flex gap-20 items-start text-center justify-center ${NationalBook.className}`}>
        {columns?.map((column, index) => (
          <div key={index} className="w-full sm:w-1/2 lg:w-auto space-y-4">
            <Column header={column?.header} links={column?.links ?? []} />
          </div>
        ))}
        <div className="flex justify-end w-150">
          <MarketButton />
        </div>
      </div>
    </div>

    {/* Mobile View including iPad Pro */}
    <ul className="flex flex-col items-center lg:hidden lg:pt-20">
      <div className="mb-20 w-[12.125rem] flex justify-center">
        <Image src={logo} alt="logo" width={143} height={26} />
      </div>
      {columns?.map((column, index) => (
        <li key={index} className="w-full text-center mb-4">
          <div className={`flex flex-col text-14 items-center ${NationalBook.className}`}>
            <Column links={column?.links ?? []} className="px-0" />
          </div>
        </li>
      ))}
      <div className="flex justify-end mt-50">
        <MarketButton />
      </div>
    </ul>

      <FooterBottom socialMedia={socialMedia} copyright={copyright} />

    </footer>
  );
}; 

//NZ commit
export default Footer;
